<template>
    <div class="kgk-user-change-email">
        <h2 v-if="!insideModal">
            E-Mail-Adresse ändern
        </h2>
        <form @submit.prevent="performUpdate">
            <div class="kgk-form-row">
                Aktuelles Passwort
                <div class="kgk-input-group">
                    <input type="password" v-model="password" name="password" required>
                </div>
                <div v-if="showValidationErrors && !passwordRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib aus Sicherheitsgründen dein bisheriges Passwort an.</div>
            </div>
            <br>
            <div class="kgk-form-row">
                Aktuelle E-Mail-Adresse
                <div class="kgk-input-group">
                    <input type="email" v-model="currentEmail" name="email" disabled>
                </div>
            </div>
            <div class="kgk-form-row">
                Neue E-Mail-Adresse
                <div class="kgk-input-group">
                    <input type="email" v-model="form.email" name="email">
                </div>
                <div v-if="showValidationErrors && !emailRequiredValidation" class="kgk-form-validation-error-inline">Du musst eine neue gültige E-Mail-Adresse angeben.</div>
            </div>
            <div v-if="!insideModal" class="kgk-form-row">
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">E-Mail-Adresse ändern</span>
                </button>
            </div>

            <!--<p>
                Blub Blub / Reset code: {{ resetCode }}
            </p>-->
        </form>
    </div>
</template>

<script>
    import user from '../../api/user';
    //import router from '../../router';

    export default {
        name: 'UserChangeEmailForm',
        components: {

        },
        props: {
            insideModal: {
                type: Boolean,
                //required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            currentEmail: {
                type: String,
                required: false,
                default: ''
            },
        },
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                },
                password: '',
                showValidationErrors: false,
                error: '',
            }
        },
        computed: {
            emailRequiredValidation() {
                return this.form.email.trim().length > 0;
            },
            passwordRequiredValidation() {
                return this.password.length > 0;
            },
        },
        methods: {
            performUpdate(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.emailRequiredValidation
                    || !this.passwordRequiredValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                this.$emit('loadingStarted');

                user.changeMail(
                    this,
                    this.form.email,
                    this.password,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'E-Mail-Adresse geändert',
                            text: 'Deine E-Mail-Adresse wurde erfolgreich geändert.'
                        });

                        this.$emit('changed');

                        //router.push('/login');
                    },
                    e => {
                        //console.error(e.response.status);

                        if( e.response.status == 400 || typeof e.response.data.message !== 'undefined' ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        this.$emit('loadingEnded');
                    }
                );
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.performUpdate();
            },
        },
        mounted() {

        }
    }
</script>

